import {FeatureCollection, Geometry} from "geojson";
import {RefObject} from "react";
import {EasingOptions, LngLatBoundsLike} from "mapbox-gl";
import bbox from "@turf/bbox";
import * as Mapbox from "react-map-gl/mapbox";
import {MapRef, ViewState} from "react-map-gl/mapbox";

/**
 * Load and prepare images to be displayed on the given map
 *
 * @param map
 */
export function loadMapImages(map: MapRef) {
    const images: Record<string, string> = {
        'exhibit-icon': '/pins/exhibit.png',
        'facility-icon': '/pins/facility.png'
    }

    Object.entries(images).forEach(([name, url]) => {
        map.loadImage(url, (error, image) => {
            if (error) throw error;
            if (image && !map.hasImage(name)) map.addImage(name, image);
        });
    })
}

/**
 * Hide the POI layers from the given map
 *
 * @param map
 */
export function hidePointsOfInterest(map: MapRef) {
    map.getStyle().layers?.forEach(layer => {
        if(layer.id.substring(0, 4) === "poi-") map.getMap().removeLayer(layer.id)
    })
}

/**
 * Get the view state for
 */

type MapboxViewState = Mapbox.MapProps['initialViewState'] | null

export function getViewState(collection: FeatureCollection, defaultViewState?: ViewState | null): MapboxViewState {
    if (collection.features.length < 1) {
        return defaultViewState ?? null;
    }

    return {
        bounds: bbox(collection) as LngLatBoundsLike,
        fitBoundsOptions: {
            padding: {top: 10, left: 10, bottom: 10, right: 10}
        }
    }
}

/**
 * Fly to the provided geometry
 */
export function flyToBounds(geometry: Geometry, mapRef: RefObject<MapRef>, options: EasingOptions = {}) {
    const map = mapRef.current?.getMap();

    if (map) {
        map.fitBounds(
          bbox(geometry) as LngLatBoundsLike,
          { padding: 40, duration: 1000, ...options}
        );
    }
}